import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUp.css";
import { UserAuth } from "../../utils/AuthContext";

function SignUp({ pageRoute }) {
  const { createUser, resetPassword } = UserAuth(); 
  const navigate = useNavigate();

  const [localLoading, setLocalLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  
  // State to control modal animation toggle
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (confirm !== password) {    
      return alert("Passwords do not match");
    }

    try {
      setError("");
      setLocalLoading(true); 
      
      // Trigger slide-out animation on submission
      setShowForm(false);

      await createUser(email, password);

      alert("User account created! A verification email has been sent to " + email);
      
      // Allow slide-out animation to finish before routing
      setTimeout(() => {
        navigate("/home");
      }, 400);
    } catch (e) {
      setError(e.message);
      alert("Registration failed: " + e.message);
      console.error(e);
      // Bring form back if registration fails
      setShowForm(true);
    } finally {
      setLocalLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      return alert("Please enter your email address first.");
    }
    try {
      await resetPassword(email);
      alert("Password reset email sent successfully!");
    } catch (e) {
      alert("Error sending reset email: " + e.message);
    }
  };

  return (
    <>
      {/* Decoupled toggle button */}
      {!showForm && (
        <button className="signUp-btn" onClick={() => setShowForm(true)}>
          Sign-Up Free
        </button>
      )}

      {/* Center overlay container */}
      <div 
        className={`signUp_overlay ${showForm ? "active" : ""}`}
        onClick={() => setShowForm(false)}
      >
        <div className="signUp_wrapper" onClick={(e) => e.stopPropagation()}>
          
          {/* Close Button */}
          <button 
            type="button" 
            className="close_btn" 
            onClick={() => setShowForm(false)}
          >
            &times;
          </button>

          {error && <p className="error-msg">{error}</p>}
          
          <form className="signUp" onSubmit={handleSubmit}>
            <div className="row">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="tyrone.biggums@crack.org"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="row">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="Capitals, Numbers, Punctuations"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="row">
              <label htmlFor="confirm">Password Confirm</label>
              <input
                id="confirm"
                type="password"
                placeholder="Capitals, Numbers, Punctuations"
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            <div className="col">
              <button type="button" onClick={handleForgotPassword} className="forgot-btn">
                Forgot Password?
              </button>
              <button disabled={localLoading} type="submit">
                {localLoading ? "Creating..." : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default SignUp;
